import { Center, Group, rem, UnstyledButton } from '@mantine/core';
import { ChevronDown, ChevronUp } from '@good/icons';
import classes from './table.module.css';
export const ThSortWrapper = ({ direction, onSort, children }) => {
    if (!direction && !onSort) {
        return <>{children}</>;
    }
    const Icon = {
        asc: <ChevronUp />,
        desc: <ChevronDown />,
    }[direction?.toString() ?? ''] ?? <ChevronDown />;
    return (<UnstyledButton onClick={onSort} fz='inherit' fw='inherit' tt='inherit' w='100%' data-sort={direction ? direction : 'false'} className={classes.control} style={{
            padding: 'var(--table-vertical-spacing) var(--table-horizontal-spacing, var(--mantine-spacing-xs))',
        }}>
      <Group wrap='nowrap' gap={4}>
        {children}
        <Center w={rem(21)} h={rem(21)} opacity={0.6}>
          {Icon}
        </Center>
      </Group>
    </UnstyledButton>);
};
